import { Badge } from "../../../../components/Badge/Badge";
import { usageTierTypes } from "../../../../constants/usage";
import { formatCurrency } from "../../../../utils/NumbersFormatting";
import type { BadgesProps } from ".";

const BadgesStripe: React.FC<BadgesProps> = ({ data }) => {
  const { planName, ptuBillingInfo } = data;
  return (
    <div className="d-grid grid-stats-section">
      <div className="row gy-5 g-xl-5 row-plex widget-container">
        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="info"
            content={{
              value: planName,
              title: "Your current plan",
            }}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="dark"
            content={{
              value: usageTierTypes[ptuBillingInfo?.currentTierId || 1]?.type,
              title: "Tier",
              tooltipText:
                "Your current tier. Purchase more credits to upgrade tiers and get better discounts.",
              rightItems: [
                {
                  icon: (
                    <span className="badge-tier-icon">
                      {usageTierTypes[ptuBillingInfo?.currentTierId || 1]?.icon}
                    </span>
                  ),
                },
              ],
            }}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="primary"
            content={{
              value: formatCurrency(
                ptuBillingInfo?.credits ? ptuBillingInfo?.credits : 0,
              ),
              title: "Credit balance",
              tooltipText:
                "Your credit balance will be consumed as you use the CogCache Proxy API.",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { BadgesStripe };
